import Vue from 'vue'
import App from './App.vue'
import 'es6-promise/auto'
import Mint from 'mint-ui'
import moment from 'moment'

import router from './router'
import store from './store'
import utils from './util/util'
import jquery from 'jquery'

import VuePreview from 'vue-preview'

import 'mint-ui/lib/style.css'
import './assets/style/iconfont/iconfont.css'
import './assets/style/iconfont2/iconfont.css'
import './assets/style/common.scss'

// 关闭vue错误提示
Vue.config.productionTip = false // 关闭生产提示
Vue.config.warnHandler = (msg, vm, trace) => {} // 完全静默警告

Vue.use(Mint)
Vue.use(VuePreview)

Vue.prototype.utils = utils

moment.locale('en_us')
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.prototype.$ = jquery

// 修改页面title
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
// new Vue({
//     el: '#app',
//     store,
//     router,
//     components: { App },
//     template: '<App/>'
// })
